module.exports = __webpack_public_path__ + "img/home4.fe67a0d2.png";